import {
  BatterReportChartConfigDto,
  BatterSessionReportChartConfigDto,
  ChartType,
  HeatmapChartConfigDto,
  PitcherReportChartConfigDto,
  PitcherSessionReportChartConfigDto,
  PitcherSingleSessionReportChartConfigDto,
  PracticeBatterSessionReportChartConfigDto,
  PracticePitcherSessionReportChartConfigDto,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

type ReportConfig =
  | BatterReportChartConfigDto
  | BatterSessionReportChartConfigDto
  | PitcherReportChartConfigDto
  | PitcherSessionReportChartConfigDto
  | PitcherSingleSessionReportChartConfigDto
  | PracticeBatterSessionReportChartConfigDto
  | PracticePitcherSessionReportChartConfigDto;

type Props<TReportConfig extends ReportConfig> = ChartConfigProps<HeatmapChartConfigDto, TReportConfig> & {
  chartId: ChartType;
  configKey: keyof TReportConfig;
  playerType: 'Batter' | 'Pitcher';
};

const StrikeZoneHeatmapChartSidebar = <T extends ReportConfig>({
  chartConfig,
  setTempLayout,
  tempLayout,
  chartId,
  configKey,
  playerType,
}: Props<T>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  let options = chartConfig.availableStats as string[];
  if (playerType === 'Pitcher') {
    options = ['PitchLocation', ...options];
  }

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartId as ChartType, chartConfig)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={options}
        selected={chartConfig.viewDataAs === 'PitchLocation' ? 'PitchLocation' : chartConfig.playerStat}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            [configKey]: {
              ...tempLayout[configKey],
              viewDataAs: selected === 'PitchLocation' ? 'PitchLocation' : 'PlayerStat',
              playerStat: selected === 'PitchLocation' ? tempLayout[configKey]['playerStat'] : selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

export default StrikeZoneHeatmapChartSidebar;
